import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {Breadcrumb} from 'semantic-ui-react'
import {
    loadOrderById
} from '../../actions/order'
import PropTypes from 'prop-types'
import Dls from '../../lib'
import OrderForm from '../forms/orders/Order'

class OrderEditPage extends Component {
    constructor() {
        super();
        this.state = {
            routeType: '',
            relationType: '',
            orderType: ''
        }
    }

    componentDidMount() {
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        const {pathname} = this.props.location;
        const {routeType, relationType, orderType} = this.setPageType(pathname);
        if (!routeType || !relationType || !orderType) {
            this.props.history.replace('/');
            return;
        }

        if (id === 'new') {
            this.props.loadOrderById(jwt, id, orderType);
        } else {
            if (parseInt(id) !== parseInt(this.props.model.id)) {
                this.props.loadOrderById(jwt, id, orderType);
            }
        }

        this.setState({
            routeType: routeType,
            relationType: relationType,
            orderType: orderType
        });
    }

    setPageType(pathname) {
        let routeType = '';
        let relationType = '';
        let orderType = '';
        if (pathname.includes('customer-orders')) {
            routeType = "customer-orders";
            relationType = "Customer";
            orderType = 'Customer Order';
        }
        if (pathname.includes('vendor-orders')) {
            routeType = "vendor-orders";
            relationType = "Vendor";
            orderType = 'Vendor Order';
        }
        if (pathname.includes('customer-returns')) {
            routeType = "customer-returns"
            relationType = "Customer";
            orderType = 'Customer Return';
        }
        if (pathname.includes('vendor-returns')) {
            routeType = "vendor-returns"
            relationType = "Vendor";
            orderType = 'Vendor Return';
        }
        return {routeType, relationType, orderType};
    }
    
    render() {
        const {model} = this.props;
        const {routeType,relationType,orderType} = this.state;
        return (
            <div>
                {_.isEmpty(model) ? <div></div> : 
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        Orders
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/${routeType}/${Dls.pagination.orders(orderType)}`}
                                        >
                                            {orderType}s
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.so : `Create New ${orderType}`}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-12">
                                {routeType ? <OrderForm 
                                    relationType={relationType} 
                                    routeType={routeType}
                                    history={this.props.history}/> : null}
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

OrderEditPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    loadOrderById: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.order.model
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadOrderById
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderEditPage)


// WEBPACK FOOTER //
// ./src/components/orders/OrderEdit.js